/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserName } from './UserName';

export type CaseDataEntry = {
    readonly id?: number;
    readonly case_id?: number;
    readonly created_at?: string;
    readonly completed_by?: UserName;
    completed_at?: string | null;
    held_at?: string | null;
    readonly held_by?: UserName;
    readonly type?: CaseDataEntry.type;
}

export namespace CaseDataEntry {

    export enum type {
        DATA_ENTRY = 'data-entry',
        BILLING = 'billing',
    }


}
